import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import {
    PromotionRedemption,
    RedemptionsByPromotionQueryVariables,
    PromotionRedemptionsByUserQueryVariables,
    PromotionRedemptionsByClientQueryVariables
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PromotionRedemptionService {
    private amplifyClient = generateClient();

    async getRedemptionsByPromotion(
        promotionId: string,
        variables?: Omit<RedemptionsByPromotionQueryVariables, 'promotionId'>
    ): Promise<PromotionRedemption[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.redemptionsByPromotion,
                    variables: { promotionId, ...variables }
                })
            ).data.redemptionsByPromotion.items;
            if (data) return data as PromotionRedemption[];
        } catch (error) {
            console.error('Error getting redemptions by promotion:', error);
            return null;
        }
    }

    async getPromotionRedemptionsByUser(
        userId: string,
        variables?: Omit<PromotionRedemptionsByUserQueryVariables, 'userId'>
    ): Promise<PromotionRedemption[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.promotionRedemptionsByUser,
                    variables: { userId, ...variables }
                })
            ).data.promotionRedemptionsByUser.items;
            if (data) return data as PromotionRedemption[];
        } catch (error) {
            console.error(
                'Error getting promotion redemptions by user:',
                error
            );
            return null;
        }
    }

    async getPromotionRedemptionsByClient(
        clientId: string,
        variables?: Omit<PromotionRedemptionsByClientQueryVariables, 'clientId'>
    ): Promise<PromotionRedemption[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.promotionRedemptionsByClient,
                    variables: { clientId, ...variables }
                })
            ).data.promotionRedemptionsByClient.items;
            if (data) return data as PromotionRedemption[];
        } catch (error) {
            console.error(
                'Error getting promotion redemptions by client:',
                error
            );
            return null;
        }
    }
}
